import React from "react";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { Divider } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const PREFIX = "KeyBenefits";

const classes = {
  smsHeading: `${PREFIX}-smsHeading`,
  smsContent: `${PREFIX}-smsContent`,
  smsPoints: `${PREFIX}-smsPoints`,
  smsPointItem: `${PREFIX}-smsPointItem`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.smsHeading}`]: {
    padding: "2em 1em 1em 2em",
    textAlign: "left",
    letterSpacing: "0.66px",
    color: "#223140",
    width: "90%",
    fontSize: 32,
    fontFamily: "AvenirLTStd-Book",
    [theme.breakpoints.down("sm")]: {
      fontSize: 25,
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: 25,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 25,
    },
  },
  [`& .${classes.smsContent}`]: {
    fontSize: 20,
    fontWeight: 100,
    color: "#223140",
    fontFamily: "AvenirLTStd-Book",
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: 25,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 25,
    },
  },
  [`& .${classes.smsPoints}`]: {
    listStyleType: "none",
    padding: "2%",
  },
  [`& .${classes.smsPointItem}`]: {
    fontSize: 20,
    fontWeight: 100,
    color: "#223140",
    fontFamily: "AvenirLTStd-Book",
    width: "90%",
    LineHeight: "100%",

    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: 16,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 16,
    },
    "& svg": {
      color: "#c20d0b",
      marginRight: "0.5em",
      fontSize: "20px",
    },
  },
  [`& .${classes.image}`]: {
    width: "100%",
    height: "auto",
  },
}));

function KeyBenefits() {
  const data = [
    {
      id: "benefits",
      title: "Key Benefits of an e-Techlog System",
      points: [
        "Ensures correct MEL use and validates signatures, reducing errors.",
        "Engineers can resolve defects quickly, minimizing turnaround times.",
        "Access flight hours, cycles, and defect data instantly, even during flight.",
        "Standardised data supports advanced forecasting & proactive planning.",
        "Flight crews can complete Remote Return to Service, no engineers needed.",
      ],
      image: "/images/benefits.png",
    },
    {
      id: "impact",
      title: "The Impact on your Operations",
      points: [
        "Maintenance becomes more efficient, reducing the impact of delays & disruptions.",
        "Streamlined workflows and real-time data means faster resolution and identification of repetitive defects, improving fleet availability & reducing turnaround times.",
        "Passengers enjoy smoother journeys, boosting satisfaction, reliability & strengthening reputation.",
        "Avoiding one AOG— often costing tens of thousands —can fully offset the annual subscription cost of the ETL. Making it an investment that delivers measurable savings & long-term operational benefits.",
      ],
      image: "/images/impact.png",
    },
  ];

  return (
    <StyledGrid container spacing={2}>
      {data.map((item, index) => (
        <React.Fragment key={item.id}>
          <Grid container spacing={2} alignItems="center">
            {index % 2 === 0 ? (
              <>
                <Grid size={{ xs: 12, md: 6 }}>
                  <Typography variant="h5" className={classes.smsHeading}>
                    {item.title}
                  </Typography>
                  <List className={classes.smsPoints}>
                    {item.points.map((point, idx) => (
                      <ListItem key={idx} className={classes.smsPointItem}>
                        <ListItemIcon>
                          <CheckCircleIcon />
                        </ListItemIcon>
                        <ListItemText primary={point} />
                      </ListItem>
                    ))}
                  </List>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className={classes.image}
                  />
                </Grid>
              </>
            ) : (
              <>
                <Grid size={{ xs: 12, md: 6 }}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className={classes.image}
                  />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                  <Typography variant="h5" className={classes.smsHeading}>
                    {item.title}
                  </Typography>
                  <List className={classes.smsPoints}>
                    {item.points.map((point, idx) => (
                      <ListItem key={idx} className={classes.smsPointItem}>
                        <ListItemIcon>
                          <CheckCircleIcon />
                        </ListItemIcon>
                        <ListItemText primary={point} />
                      </ListItem>
                    ))}
                  </List>
                </Grid>
              </>
            )}
          </Grid>
          {index < data.length - 1 && <Divider style={{ margin: "24px 0" }} />}
        </React.Fragment>
      ))}
    </StyledGrid>
  );
}

export default KeyBenefits;
